module.exports = __webpack_public_path__ + "static/img/gzzShade1.5e1aac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzzShade1.png
// module id = BFru
// module chunks = 2